<template>
  <div class="contact-view">
    <table class="table table-sm table-fixed table-bordered">
      <tbody>
        <tr class="thead-light">
          <th>Selected</th>
          <th>Not selected</th>
        </tr>
        <tr>
          <td>
            <span v-for="study in selected" :key="study.id">
              {{study.name}}
              <br />
            </span>
          </td>
          <td>
            <span v-for="study in unselected" :key="study.id">
              {{study.name}}
              <br />
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "StudyView",
  computed: {
    selected() {
      const selected = [];
      const studies = this.$store.getters.studies;
      const data = this.$store.state.subscriberData;
      for (const study of studies) {
        if (data[study.id]) {
          selected.push(study);
        }
      }
      return selected;
    },
    unselected() {
      const selected = [];
      const studies = this.$store.getters.studies;
      const data = this.$store.state.subscriberData;
      for (const study of studies) {
        if (!data[study.id]) {
          selected.push(study);
        }
      }
      return selected;
    }
  }
};
</script>